/**
 * @fileoverview gRPC-Web generated client stub for acompanha.tickets.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.2
// source: acompanha/tickets/v1/tickets.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.acompanha = {};
proto.acompanha.tickets = {};
proto.acompanha.tickets.v1 = require('./tickets_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.tickets.v1.TicketsServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.tickets.v1.TicketsServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.tickets.v1.GetTicketMetaRequest,
 *   !proto.acompanha.tickets.v1.GetTicketMetaResponse>}
 */
const methodDescriptor_TicketsService_GetTicketMeta = new grpc.web.MethodDescriptor(
  '/acompanha.tickets.v1.TicketsService/GetTicketMeta',
  grpc.web.MethodType.UNARY,
  proto.acompanha.tickets.v1.GetTicketMetaRequest,
  proto.acompanha.tickets.v1.GetTicketMetaResponse,
  /**
   * @param {!proto.acompanha.tickets.v1.GetTicketMetaRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.tickets.v1.GetTicketMetaResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.tickets.v1.GetTicketMetaRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.tickets.v1.GetTicketMetaResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.tickets.v1.GetTicketMetaResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.tickets.v1.TicketsServiceClient.prototype.getTicketMeta =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.tickets.v1.TicketsService/GetTicketMeta',
      request,
      metadata || {},
      methodDescriptor_TicketsService_GetTicketMeta,
      callback);
};


/**
 * @param {!proto.acompanha.tickets.v1.GetTicketMetaRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.tickets.v1.GetTicketMetaResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.tickets.v1.TicketsServicePromiseClient.prototype.getTicketMeta =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.tickets.v1.TicketsService/GetTicketMeta',
      request,
      metadata || {},
      methodDescriptor_TicketsService_GetTicketMeta);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.tickets.v1.ListTicketsRequest,
 *   !proto.acompanha.tickets.v1.ListTicketsResponse>}
 */
const methodDescriptor_TicketsService_ListTickets = new grpc.web.MethodDescriptor(
  '/acompanha.tickets.v1.TicketsService/ListTickets',
  grpc.web.MethodType.UNARY,
  proto.acompanha.tickets.v1.ListTicketsRequest,
  proto.acompanha.tickets.v1.ListTicketsResponse,
  /**
   * @param {!proto.acompanha.tickets.v1.ListTicketsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.tickets.v1.ListTicketsResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.tickets.v1.ListTicketsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.tickets.v1.ListTicketsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.tickets.v1.ListTicketsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.tickets.v1.TicketsServiceClient.prototype.listTickets =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.tickets.v1.TicketsService/ListTickets',
      request,
      metadata || {},
      methodDescriptor_TicketsService_ListTickets,
      callback);
};


/**
 * @param {!proto.acompanha.tickets.v1.ListTicketsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.tickets.v1.ListTicketsResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.tickets.v1.TicketsServicePromiseClient.prototype.listTickets =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.tickets.v1.TicketsService/ListTickets',
      request,
      metadata || {},
      methodDescriptor_TicketsService_ListTickets);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.tickets.v1.GetTicketRequest,
 *   !proto.acompanha.tickets.v1.GetTicketResponse>}
 */
const methodDescriptor_TicketsService_GetTicket = new grpc.web.MethodDescriptor(
  '/acompanha.tickets.v1.TicketsService/GetTicket',
  grpc.web.MethodType.UNARY,
  proto.acompanha.tickets.v1.GetTicketRequest,
  proto.acompanha.tickets.v1.GetTicketResponse,
  /**
   * @param {!proto.acompanha.tickets.v1.GetTicketRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.tickets.v1.GetTicketResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.tickets.v1.GetTicketRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.tickets.v1.GetTicketResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.tickets.v1.GetTicketResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.tickets.v1.TicketsServiceClient.prototype.getTicket =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.tickets.v1.TicketsService/GetTicket',
      request,
      metadata || {},
      methodDescriptor_TicketsService_GetTicket,
      callback);
};


/**
 * @param {!proto.acompanha.tickets.v1.GetTicketRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.tickets.v1.GetTicketResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.tickets.v1.TicketsServicePromiseClient.prototype.getTicket =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.tickets.v1.TicketsService/GetTicket',
      request,
      metadata || {},
      methodDescriptor_TicketsService_GetTicket);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.tickets.v1.CreateTicketRequest,
 *   !proto.acompanha.tickets.v1.CreateTicketResponse>}
 */
const methodDescriptor_TicketsService_CreateTicket = new grpc.web.MethodDescriptor(
  '/acompanha.tickets.v1.TicketsService/CreateTicket',
  grpc.web.MethodType.UNARY,
  proto.acompanha.tickets.v1.CreateTicketRequest,
  proto.acompanha.tickets.v1.CreateTicketResponse,
  /**
   * @param {!proto.acompanha.tickets.v1.CreateTicketRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.tickets.v1.CreateTicketResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.tickets.v1.CreateTicketRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.tickets.v1.CreateTicketResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.tickets.v1.CreateTicketResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.tickets.v1.TicketsServiceClient.prototype.createTicket =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.tickets.v1.TicketsService/CreateTicket',
      request,
      metadata || {},
      methodDescriptor_TicketsService_CreateTicket,
      callback);
};


/**
 * @param {!proto.acompanha.tickets.v1.CreateTicketRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.tickets.v1.CreateTicketResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.tickets.v1.TicketsServicePromiseClient.prototype.createTicket =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.tickets.v1.TicketsService/CreateTicket',
      request,
      metadata || {},
      methodDescriptor_TicketsService_CreateTicket);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.tickets.v1.AddTicketMessageRequest,
 *   !proto.acompanha.tickets.v1.AddTicketMessageResponse>}
 */
const methodDescriptor_TicketsService_AddTicketMessage = new grpc.web.MethodDescriptor(
  '/acompanha.tickets.v1.TicketsService/AddTicketMessage',
  grpc.web.MethodType.UNARY,
  proto.acompanha.tickets.v1.AddTicketMessageRequest,
  proto.acompanha.tickets.v1.AddTicketMessageResponse,
  /**
   * @param {!proto.acompanha.tickets.v1.AddTicketMessageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.tickets.v1.AddTicketMessageResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.tickets.v1.AddTicketMessageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.tickets.v1.AddTicketMessageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.tickets.v1.AddTicketMessageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.tickets.v1.TicketsServiceClient.prototype.addTicketMessage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.tickets.v1.TicketsService/AddTicketMessage',
      request,
      metadata || {},
      methodDescriptor_TicketsService_AddTicketMessage,
      callback);
};


/**
 * @param {!proto.acompanha.tickets.v1.AddTicketMessageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.tickets.v1.AddTicketMessageResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.tickets.v1.TicketsServicePromiseClient.prototype.addTicketMessage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.tickets.v1.TicketsService/AddTicketMessage',
      request,
      metadata || {},
      methodDescriptor_TicketsService_AddTicketMessage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.tickets.v1.UpdateTicketStatusRequest,
 *   !proto.acompanha.tickets.v1.UpdateTicketStatusResponse>}
 */
const methodDescriptor_TicketsService_UpdateTicketStatus = new grpc.web.MethodDescriptor(
  '/acompanha.tickets.v1.TicketsService/UpdateTicketStatus',
  grpc.web.MethodType.UNARY,
  proto.acompanha.tickets.v1.UpdateTicketStatusRequest,
  proto.acompanha.tickets.v1.UpdateTicketStatusResponse,
  /**
   * @param {!proto.acompanha.tickets.v1.UpdateTicketStatusRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.tickets.v1.UpdateTicketStatusResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.tickets.v1.UpdateTicketStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.tickets.v1.UpdateTicketStatusResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.tickets.v1.UpdateTicketStatusResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.tickets.v1.TicketsServiceClient.prototype.updateTicketStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.tickets.v1.TicketsService/UpdateTicketStatus',
      request,
      metadata || {},
      methodDescriptor_TicketsService_UpdateTicketStatus,
      callback);
};


/**
 * @param {!proto.acompanha.tickets.v1.UpdateTicketStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.tickets.v1.UpdateTicketStatusResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.tickets.v1.TicketsServicePromiseClient.prototype.updateTicketStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.tickets.v1.TicketsService/UpdateTicketStatus',
      request,
      metadata || {},
      methodDescriptor_TicketsService_UpdateTicketStatus);
};


module.exports = proto.acompanha.tickets.v1;

